import React from 'react';

export default function Contact(props) {
    return <div>Contact information</div>;
};



